module.exports = __webpack_public_path__ + "static/media/sainikdp.699eed3e.jpeg";